import React from 'react';
import { Grid, Typography } from '@mui/material';
import { PageContent } from '../PageContent';

const ErrorFallback = () => {
  return (
    <PageContent>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item>
          <Typography variant="h2">An unexpected error occurred.</Typography>
        </Grid>
      </Grid>
    </PageContent>
  );
};

export default ErrorFallback;
